import { Alert, AlertDescription, AlertTitle } from '@kognitos/lattice';
import { useTranslation } from 'react-i18next';

export const AccessDeniedAlert = () => {
  const { t: tCommon } = useTranslation('common');

  return (
    <Alert variant="destructive">
      <AlertTitle>{tCommon('common.accessDenied.title')}</AlertTitle>

      <AlertDescription>
        {tCommon('common.accessDenied.description')}
      </AlertDescription>
    </Alert>
  );
};
